// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__R7z0f","rootSmall":"AddTileButton_rootSmall__3NRYg"};